import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/promiseFrame/warn_red.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1477ebb5")

_pushScopeId("data-v-1477ebb5")
const _hoisted_1 = { class: "ui__checkTitle" }
const _hoisted_2 = { class: "checkTitle-left" }
const _hoisted_3 = { class: "title-text" }
const _hoisted_4 = { class: "title-count" }
const _hoisted_5 = {
  key: 0,
  class: "warning-icon",
  src: _imports_0
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.titleCont), 1),
      _createVNode("span", _hoisted_4, _toDisplayString(_ctx.allCount) + "项检测", 1)
    ]),
    _createVNode("div", {
      class: "checkTitle-right",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleToggle && _ctx.handleToggle(...args)))
    }, [
      (_ctx.showWarningIcon)
        ? (_openBlock(), _createBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode("span", {
        class: ["status-text", {'abnormal': _ctx.hasDefect && Number(_ctx.count) > 0}]
      }, _toDisplayString(_ctx.statusText), 3),
      _createVNode("img", {
        class: "arrow",
        src: _ctx.arrowIcon
      }, null, 8, ["src"])
    ])
  ]))
})